import React from 'react';
import { Lightbulb } from 'lucide-react';
export const KongWang: React.FC = () => {
  const xunGroups = [{
    name: '甲子旬',
    branches: '子丑寅卯辰巳午未申酉',
    void: '戌、亥'
  }, {
    name: '甲戌旬',
    branches: '戌亥子丑寅卯辰巳午未',
    void: '申、酉'
  }, {
    name: '甲申旬',
    branches: '申酉戌亥子丑寅卯辰巳',
    void: '午、未'
  }, {
    name: '甲午旬',
    branches: '午未申酉戌亥子丑寅卯',
    void: '辰、巳'
  }, {
    name: '甲辰旬',
    branches: '辰巳午未申酉戌亥子丑',
    void: '寅、卯'
  }, {
    name: '甲寅旬',
    branches: '寅卯辰巳午未申酉戌亥',
    void: '子、丑'
  }];
  return <div className="space-y-12" data-id="element-183">
      <div className="text-center mb-10" data-id="element-184">
        <h1 className="text-3xl font-serif font-bold text-gold-dark mb-4" data-id="element-185">
          空亡理论
        </h1>
        <p className="text-ink-light" data-id="element-186">
          天干十个，地支十二个，配对时总有两个地支轮空，这就是"空亡"。
        </p>
      </div>

      <div className="bg-gold/5 border border-gold/20 p-6 rounded-lg flex gap-4 items-start" data-id="element-187">
        <div className="bg-gold/20 p-2 rounded-full text-gold-dark shrink-0" data-id="element-188">
          <Lightbulb size={24} data-id="element-189" />
        </div>
        <div data-id="element-190">
          <h3 className="font-serif font-bold text-gold-dark text-lg mb-2" data-id="element-191">
            小白理解法：抢椅子游戏
          </h3>
          <p className="text-ink-light text-sm leading-relaxed" data-id="element-192">
            想象10个男生（天干）和12个女生（地支）相亲配对。
            <br data-id="element-193" />
            一轮配对下来，肯定有2个女生落单了。这2个落单的地支，在这一轮（一旬）里就叫"空亡"。
            <br data-id="element-194" />
            空亡代表力量减弱、落空、不在状态。如果财星空亡，可能财来财去；如果印星空亡，可能与母亲缘分较浅。
          </p>
        </div>
      </div>

      <section className="space-y-6" data-id="element-195">
        <h2 className="text-2xl font-serif text-gold-dark border-l-4 border-gold pl-3" data-id="element-196">
          六旬空亡表
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-197">
          {xunGroups.map((group, idx) => <div key={idx} className="bg-white ink-border p-5 rounded-lg shadow-sm" data-id="element-198">
              <div className="flex justify-between items-center mb-3" data-id="element-199">
                <h3 className="text-lg font-serif font-bold text-ink" data-id="element-200">
                  {group.name}
                </h3>
                <span className="text-sm bg-cinnabar/10 px-2 py-1 rounded text-cinnabar font-bold" data-id="element-201">
                  空 {group.void}
                </span>
              </div>
              <p className="text-ink-light text-xs break-all tracking-widest" data-id="element-202">
                {group.branches}
              </p>
            </div>)}
        </div>
      </section>
    </div>;
};